import { API_METHOD, BASE_API_URL } from "@/constants";
import { fetcher } from "@/lib/fetcher.config";
import { DirectInvocationResponse, TrustScoreResponse } from "@/types";

// Check URL
export async function checkUrl({ url }: { url: string }): Promise<DirectInvocationResponse> {
  return fetcher(`${BASE_API_URL}/check`, {
    method: API_METHOD.POST,
    body: JSON.stringify({
      url: decodeURIComponent(url),
    }),
  });
}

// Check URL
export async function crawlUrl({
  url,
  jobId,
}: {
  url: string;
  jobId: string;
}): Promise<TrustScoreResponse> {
  return fetcher(`${BASE_API_URL}/crawl`, {
    method: API_METHOD.POST,
    body: JSON.stringify({
      url: decodeURIComponent(url),
      jobId,
    }),
  });
}
